// tslint:disable-next-line: no-var-requires
const path = require('path');

/********************************自动导包 start********************************/
// tslint:disable-next-line: no-var-requires
const file = require.context('./', true, /\index.ts/);

const childModules: { [propsName: string]: any } = {};
file.keys().forEach((key: string) => {
  const name = path.normalize(path.dirname(key));

  childModules[name] = file(key).default || file(key);
});

/********************************自动导包 end********************************/

const module={
    namespaced: true,
    state:{
        
    },
    actions:{
    },
    modules: {
        ...childModules
    }
}
export default module;